import useApiRequest from 'api/useApiRequest';
import {
  uploadFiles,
  addUploadHubItem,
  fetchUploadHubList,
  updateUploadHubItem,
  deleteUploadHubItem,
  fetchUploadHubBranding,
  updateUploadHubBranding,
  type UploadHubListItem,
} from 'api/services/uploadFileService';

const useUploadFiles = () => {
  const { request } = useApiRequest();

  const uploadFile = async (params: Parameters<typeof uploadFiles>[1]) => {
    const { data } = await uploadFiles(request, params);
    return data;
  };

  const addItemToUploadHub = async (params: Parameters<typeof addUploadHubItem>[1]) => {
    const { data } = await addUploadHubItem(request, params);
    return data;
  };

  const uploadPendingFiles = async (pendingFiles: File[]): Promise<UploadHubListItem[]> => {
    const links: string[] = await uploadFile({ files: pendingFiles });
    const files = (links ?? []).map((url: string, index: number) => ({
      url,
      fileName: pendingFiles[index]?.name,
      contentType: pendingFiles[index]?.type,
      fileSizeBytes: pendingFiles[index]?.size,
    }));
    const createdItems: UploadHubListItem[] = await addItemToUploadHub({ files });
    return createdItems ?? [];
  };

  const getUploadHubList = async (params: Parameters<typeof fetchUploadHubList>[1]) => {
    const { data } = await fetchUploadHubList(request, params);
    return data;
  };

  const updateItemFromUploadHub = async (params: Parameters<typeof updateUploadHubItem>[1]) => {
    const { data } = await updateUploadHubItem(request, params);
    return data;
  };

  const deleteItemFromUploadHub = async (params: Parameters<typeof deleteUploadHubItem>[1]) => {
    const { data, status } = await deleteUploadHubItem(request, params);
    return { data, status };
  };

  const getUploadHubBranding = async (params: Parameters<typeof fetchUploadHubBranding>[1]) => {
    const { data, status } = await fetchUploadHubBranding(request, params);
    return { data, status };
  };

  const updateBrandingForUploadHub = async (params: Parameters<typeof updateUploadHubBranding>[1]) => {
    const { data } = await updateUploadHubBranding(request, params);
    return data;
  };

  return {
    uploadFile,
    addItemToUploadHub,
    uploadPendingFiles,
    getUploadHubList,
    updateItemFromUploadHub,
    deleteItemFromUploadHub,
    getUploadHubBranding,
    updateBrandingForUploadHub,
  };
};

export default useUploadFiles;
